export default [
  {
    path: '/franchise/',
    name: 'franchise',
    component: () => import(/* webpackChunkName: "mozgo-party" */ '../views/mozgo-franchise/mozgo-franchise.vue'),
    redirect: () => {
      window.location = 'https://partners.mozgo.com/?utm_source=mozgocom';
    },
    meta: {
      layout: 'homepage',
      mode: 'result',
      title: 'Франшиза "Мозгобойня"',
      metaTags: [{
        name: 'description',
        value: 'Минимальные вложения и срок окупаемости. Барная викторина, которая уже покорила 219 городов мира!',
      }],
    },
  },
];
